export enum Entity {
  MESSAGES = 'messages',
  FILES = 'files',
  BULKS = 'bulks',
  BATCHES = 'batches',
  PROFILES = 'profiles',
  RULES = 'rules',
  ARCHIVE = 'archive'
}
